import axios from 'axios';
import { getCurrentUser } from './authService';
import config from '../config/config';

const API_ROOT = `${config.api.baseUrl}/api`;

function authHeader() {
  const current = getCurrentUser();
  if (current?.token) {
    return { 'x-auth-token': current.token };
  }
  return {};
}

export async function postFormCheck(payload) {
  const response = await axios.post(
    `${API_ROOT}/form-check`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        ...authHeader()
      },
      maxBodyLength: Infinity,
      maxContentLength: Infinity
    }
  );
  return response.data;
}

export async function requestFormCheckTts(text) {
  const response = await axios.post(
    `${API_ROOT}/form-check/tts`,
    { text },
    {
      headers: {
        'Content-Type': 'application/json',
        ...authHeader()
      }
    }
  );
  return response.data;
}
